<nb-card class="solicitar-autorizacion-dialog">

  <nb-card-header>
    Solicitar autorización
  </nb-card-header>

  <nb-card-body>


      <p>
        Para poder utilizar VisorCUE el titular de la empresa unipersonal debe solicitar
        autorización para que AIDIAPP acceda a los datos REA (Registro de Explotaciones
        Agrícolas) de su comunidad autónoma. Puede descargar el modelo de autorización,
        imprimirlo, firmarlo, escanearlo y subirlo a través de esta misma página utilizando
        la opción ENVIAR AUTORIZACION.
        También puede solicitar la autorización desde la aplicación Visor SIGPAC accediendo
        al menú Mi explotación del menú lateral.
      </p>




    <div class="acciones">

      <button
        nbButton
        status="info"
        [disabled]="loading"
        (click)="descargarModelo()">

        DESCARGAR MODELO

      </button>

    </div>


   <ng-container>

    <hr>

    <div class="subir-pdf">

      <label>
        Seleccione el PDF de autorización:
      </label>

      <input
        type="file"
        accept="application/pdf"
        (change)="seleccionarArchivo($event)"
        [disabled]="loading"
      >

      <div
        *ngIf="fileName"
        class="nombre-archivo">

        Archivo seleccionado:
        <strong>
          {{ fileName }}
        </strong>

      </div>

    </div>

    <div class="acciones">

      <button
        nbButton
        status="primary"
        [disabled]="loading || !fileBase64"
        (click)="enviarAutorizacion()">

        ENVIAR AUTORIZACION

      </button>

    </div>

   </ng-container>

  </nb-card-body>


</nb-card>
